import React from "react";
import { Title } from "../components/Title";
export class OpenTime extends React.Component {
    render(): React.ReactNode {
        return (

            <div className="openTime">
                <div className="content">
                 <Title title="开放时间"></Title>
              
                <div className="openTimeContent time">
                    <div>09:00</div>
                    <div className="bar"></div>
                    <div>16:30</div>
                    <div className="bar"></div>
                    <div>17:00</div>
                   
                    <div className="info">开放入馆时间</div>
                    <div></div>
                    <div className="info">停止入馆时间</div>
                    <div></div>
                    <div className="info">闭馆时间</div>
                   
                </div>
                <div>
                    <p className="openText">本馆免费开放，除法定节假日，全年实行周一闭馆<br/></p>
                    <p className="notice">遇有重大活动或重要设备设施维修保养时，可根据需要临时闭馆，届时将预先告示公众，详情请关注太仓博物馆官网</p>
                </div>
                </div>
            </div>

        )
    }
}